import { PageIcon } from "@/components/PageIcon";
import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Mail } from "lucide-react";

export const EM_TABS = [
  ["", "Overview", "overview"], ["campaigns", "Campaigns", "campaigns"], ["subscribers", "Subscribers", "subscribers"], ["eligibility", "Consent review", "eligibility"],
  ["lists", "Lists & Segments", "lists"], ["automations", "Automations", "automations"], ["templates", "Templates", "templates"],
  ["analytics", "Analytics", "analytics"], ["settings", "Settings", "settings"],
];

export default function EmailMarketingLayout() {
  return (
    <div className="px-4 sm:px-6 lg:px-8 pt-3 lg:pt-4 pb-6 lg:pb-8 space-y-5" data-testid="email-marketing-layout">
      <div className="flex items-center gap-3">
        <span className="w-10 h-10 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center"><Mail className="w-5 h-5" /></span>
        <div className="min-w-0">
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight flex items-center gap-3"><PageIcon />Email Marketing</h1>
          <p className="text-sm text-slate-500">Subscribers, consent and campaigns for this company</p>
        </div>
      </div>
      <nav className="flex gap-1 overflow-x-auto border-b border-slate-200 -mx-1 px-1" data-testid="em-tabs">
        {EM_TABS.map(([to, label, id]) => (
          <NavLink key={id} to={to ? `/email-marketing/${to}` : "/email-marketing"} end={!to} data-testid={`em-tab-${id}`}
            className={({ isActive }) => `whitespace-nowrap px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${isActive ? "border-indigo-600 text-indigo-700" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
            {label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
